/**
 * Legacy photo lists of the acceptance cards (top-level fields of the project), shown and granted
 * by the block project-acceptance-report-data. Must match `PROJECT_ACCEPTANCE_REPORT_PHOTO_FIELDS`
 * in apps/apolloserver (services/projectBlocks.ts).
 */
export const PROJECT_ACCEPTANCE_REPORT_PHOTO_FIELDS = [
  'damageAttachments',
  'scaffoldAttachments',
  'jobSafetyOptionalAttachments',
  'ballastAttachments',
  'railToRoofDistanceAttachments',
  'earthingSubstructureAttachments',
  'brickCoverWidthAttachments',
  'correctBrickHandlingAttachments',
  'roofHookWithEarthingAttachments',
  'correctCableInputAttachments',
  'protectedUnderBrickCableRoutingAttachments',
  'brickAndSubstructureAttachments',
  'brickAndSubstructureOptionalAttachments',
  'stringPlanAttachments',
  'allPanelsVisibleAttachments',
  'clampAreaAttachments',
  'trayfDistanceAttachments',
  'railOverlapAttachments',
  'panelBottomViewAttachments',
  'solarModuleTypePlateAttachments',
  'solarPanelsOptionalAttachments',
  'cableManagementAttachments',
  'cableAlongFacadeAttachments',
  'cableManagementOptionalAttachments',
  'inverterAttachments',
  'inverterSerialNumberAttachments',
  'mateboxSerialNumberAttachments',
  'storageSerialNumberAttachments',
  'dongleSerialNumberAttachments',
  'openMateboxAttachments',
  'cableBetweenMateboxAndElectricMeterAttachments',
  'variousBreakthroughsWithPossibleSealingsAttachments',
  'inverterOptionalAttachments',
  'equipotentialBusBarAttachments',
  'potentialGroundRodAttachments',
  'potentialOptionalAttachments',
  'openHAKAttachments',
  'closedHAKWithSealAttachments',
  'electricMeterAttachments',
  'electricMeterReadingAttachments',
  'gakAttachments',
  'openMeterCabinetPrePostAreaAttachments',
  'closedMeterCabinetInscribedComponentsAttachments',
  'closedPreMeterAreaWithPlombsAttachments',
  'breakthroughsWithSealingsMeterCabinetAttachments',
  'electricMeterAndGakOptionalAttachments',
  'photoOfWallboxAttachments',
  'accessCardsOfWallboxAttachments',
  'circuitBreakerAndSafetySwitchForWallboxAttachments',
  'cablingBetweenWallboxAndDistributionAttachments',
  'screenshotDeviceFlow',
  'screenshotModeOfOperation',
  'netConnectionTerms',
  'monitoringOptionalAttachments',
  'measurementResultAttachments',
  'measurementProtocolInclPhotosAttachments',
  'measurementsOptionalAttachments',
  'warrantyQCellsAttachments',
  'acceptanceProtocolCustomerSignatureAttachments',
];
